module.exports = __webpack_public_path__ + "img/pipe_left.f4f93439.svg";